import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const MissaleComplaintBarChart = () => {
  const data = {
    labels: ['H1', 'H2'],
    datasets: [
      {
        label: 'FY24',
        data: [146, 417], // H1 and H2 for FY24
        backgroundColor: 'gray',
      },
      {
        label: 'FY25',
        data: [246, 417], // H1 and H2 for FY25
        backgroundColor: '#005E9E',
      },
    ]
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },

      datalabels: {
        color: "white",
        font: {
          weight: "bold",
        }
    },
    },
    scales: {
      y: {
        beginAtZero: true,
      },
    },
    
  };

  return <Bar data={data} options={options} />;
};

export default MissaleComplaintBarChart;
